import Vue from 'vue'
import Router from 'vue-router'
import loginIn from '@/components/login/loginIn' // 登录、注册
import authCode from '@/components/login/authCode' // 输入验证码
import chooseCountry from '@/components/login/chooseCountry' // 选择国家/地区
import agreement from '@/components/login/agreement' // 协议
import homePage from '@/components/homepage/homePage' // 首页
import homePageChannel from '@/components/homepage/homePageChannel' // 专区首页
import search from '@/components/homepage/search' // 商品搜索
import searchItemList from '@/components/homepage/searchItemList' // 搜索结果
import recommendList from '@/components/homepage/recommendList' // 小编推荐列表
import feedback from '@/components/user/feedback' // 意见反馈
import feedbackList from '@/components/user/feedbackList' // 意见反馈列表
import feedbackDetails from '@/components/user/feedbackDetails' // 意见反馈详情
import messageCenter from '@/components/message/messageCenter' // 消息中心
import noticeMessage from '@/components/message/noticeMessage' // 。。消息
import personNoticeMessage from '@/components/message/personNoticeMessage' // 。。消息
import logisticsMessage from '@/components/message/logisticsMessage' // 。。消息
import selectActivities from '@/components/homepage/selectActivities' // 精选活动
import newPerson from '@/components/homepage/newPerson' // 新人专区-没用过
import newProduct from '@/components/homepage/newProduct' // 新品上市-没用过
import giftBagProduct from '@/components/homepage/giftBagProduct' // 分组商品链接/引流、礼包商品列表
import bestSell from '@/components/homepage/bestSell' // 畅销榜
import personalCenter from '@/components/user/personalCenter' // 我的
import footprint from '@/components/user/footprint' // 浏览足迹
import help from '@/components/user/help' // 帮助中心
import helpContent from '@/components/user/helpContent' // 问题详情
import perInfo from '@/components/user/personalInfo' // 个人信息
import updateMessage from '@/components/user/updateMessage' // 修改昵称/姓名
import setting from '@/components/user/setting' // 设置
import addressManagement from '@/components/user/addressManagement' // 地址管理
import addAddress from '@/components/user/addAddress' // 添加地址
import editAddress from '@/components/user/editAddress' // 修改地址
import updatePhone from '@/components/phone/updatePhone' // 更换手机号
import inputPhone from '@/components/phone/inputPhone' // 更换手机号
import updatePhoneCode from '@/components/phone/updatePhoneCode' // 更换手机号
import boundPhone from '@/components/phone/boundPhone' // 绑定手机号
import boundChooseCountry from '@/components/phone/boundChooseCountry' // 绑定手机号
import boundPhoneCode from '@/components/phone/boundPhoneCode' // 绑定手机号
import storeInfo from '@/components/user/storeInfo' // 店铺信息
import inviteFriends from '@/components/user/inviteFriends' // 邀请好友
import aboutUs from '@/components/user/aboutUs' // 关于我们
import donateList from '@/components/user/donateList' // 我的捐赠
import cashCoupon from '@/components/user/cashCoupon' // 现金劵
import integralCenter from '@/components/integral/integralCenter' // 积分中心
import integralTask from '@/components/integral/integralTask' // 积分中心
import integralDetails from '@/components/integral/integralDetails' // 积分明细
import integralRule from '@/components/integral/integralRule' // 积分规则
import integralProductDetail from '@/components/integral/integralProductDetail' // 积分商品详情
import addOrderIntegral from '@/components/integral/addOrderIntegral' // 积分商品订单确认
import collection from '@/components/user/collection' // 收藏
import myOrder from '@/components/order/myOrder' // 我的订单
import orderSearch from '@/components/order/orderSearch' // 订单搜索
import orderSearchList from '@/components/order/orderSearchList' // 订单搜索结果
import orderDetails from '@/components/order/orderDetails' // 订单详情
import productEvaluation from '@/components/order/productEvaluation' // 商品评价
import splitDetails from '@/components/order/splitDetails' // 拆单详情
import splitdetails_order from '@/components/order/splitDetails_order' // 拆单详情-订单中心拆单
import relationorders from '@/components/order/relationorders' // 补发订单列表
import afterType from '@/components/after/afterType' // 选择售后类型
import salesReturn from '@/components/after/salesReturn' // 修改退货原因
import refundSalesReturn from '@/components/after/refundSalesReturn' // 填写退货原因
import ReturnSubsequent from '@/components/after/ReturnSubsequent' // 更改退货信息
// import chooseCourier from '@/components/after/chooseCourier' // 更改物流公司
import afterDetails from '@/components/after/afterDetails' // 售后详情
import afterEvaluation from '@/components/after/afterEvaluation' // 售后评价
import logisticsDetails from '@/components/order/logisticsDetails' // 查看物流
import myPrize from '@/components/prize/myPrize' // 我的奖品
import addOrderPrize from '@/components/prize/addOrderPrize' // 我的奖品确认订单
import getDetails from '@/components/prize/getDetails' // 领取详情
// import orderDetailsPrize from '@/components/prize/orderDetailsPrize' // 我的奖品订单详情 作废
import category from '@/components/category/category' // 分类
import productCategory from '@/components/category/productCategory' // 商品分类
import brandList from '@/components/category/brandList' // 精选专区（品牌列表）
import productDetail from '@/components/productdetail/productDetail' // 商品详情
import newproductDetail from '@/components/productdetail/newproductDetail' // 29.9活动详情
import commentDetail from '@/components/productdetail/commentDetail' // 评论详情
import cart from '@/components/shopcart/cart' // 购物车
import addressChoose from '@/components/shopcart/addressChoose' // 选择地址
import commentList from '@/components/productdetail/commentList' // 评论列表
import order from '@/components/shopcart/addOrder' // 订单确认
import identity from '@/components/shopcart/identity' // 实名认证
import pay from '@/components/order/pay' // 支付
import payResult from '@/components/order/payResult' // 支付结果
import ndoIndex from '@/components/ndo/index' // 糖化测试
import ndoResult from '@/components/ndo/result' // 糖化测试
import communityPromoteAct from '@/components/actpage/communityPromoteAct' // 店铺福利
import getcoupon from '@/components/productdetail/getCoupon' // 活动~领券中心
import actintroduce from '@/components/38actpage/actintroduce'
import friendactintroduce from '@/components/38actpage/friendactintroduce' // 新人臻享 专享礼遇 活动
import msindex from '@/components/38actpage/msindex' // 限时抢购
import msproductDetail from '@/components/productdetail/msproductDetail' // 限时抢购秒杀详情页
import jzdzlbindex from '@/components/giftactpage/jzdzlbindex' // 钜惠店主礼包活动 及商城4.0app交互
import jzdzlbproductDetail from '@/components/productdetail/jzdzlbproductDetail' // 钜惠店主礼包活动商品详情 及商城4.0app交互
// 社区
import community from '@/components/community/communityIndex'
import communitySearch from '@/components/community/communitySearch'
import communitySearchResult from '@/components/community/communitySearchResult'
import communityEvaluation from '@/components/community/communityEvaluation'
import communityTopic from '@/components/community/communityTopic'
import crossSellProducts from '@/components/community/cross-sellProducts'
import communityDetail from '@/components/community/communityDetail'
import communityReport from '@/components/community/communityReport'
import fansList from '@/components/community/fansList'
import communityCenter from '@/components/community/communityCenter'
import draftList from '@/components/community/draftList'
import topicList from '@/components/community/topicList'
import communityMsg from '@/components/community/communityMsg'
import communityFollow from '@/components/community/communityFollow'
import certification from '@/components/community/certification' // 创作者
import updateintroduce from '@/components/community/updateintroduce'
import submitsuccessful from '@/components/emptypage/submitsuccessful'
import rewarddetails from '@/components/community/rewarddetails'
import creditscoreresume from '@/components/community/creditscoreresume'
import dataCenter from '@/components/community/dataCenter'
// 超值加购+换购
import productList from '@/components/productList/productList'
import allProductList from '@/components/productList/allProductList'
import product from '@/components/productList/productDetail'
// 双12赠品列表（2020/11/30）满赠
import freeGiftZone from '@/components/shopcart/freeGiftZone'
// 买赠赠品列表
import freeGiftZone_buyGift from '@/components/shopcart/freeGiftZone_buyGift'
// 收单商品
import recommendProducts from '@/components/shopcart/recommendProducts'
// 皮肤分析
import skinAnalysis from '@/components/skinAnalysis/index'
import analysisDetail from '@/components/skinAnalysis/detail'
import analysisDetailposter from '@/components/skinAnalysis/detailposter'
import skinQuestioin from '@/components/skinAnalysis/question'
import skinProducts from '@/components/skinAnalysis/skinProducts'
import skinRecords from '@/components/skinAnalysis/records'

import exclusivelist from '@/components/exclusivelist/exclusivelist'
// 领券 可用商品
import couponproduct from '@/components/couponproduct/couponproduct'

// 店铺变更
import personinfofill from '@/components/storechange/personinfofill'
import openingbank from '@/components/storechange/openingbank'
import identityauth from '@/components/storechange/identityauth'
import identityauthsucc from '@/components/storechange/identityauthsucc'

import emplmsindex from '@/components/emplwelfare/emplmsindex'

// 新品试用
import newproducthome from '@/components/newproducttrial/home'
import newproductdetail from '@/components/newproducttrial/newproductdetail'
import powerlist from '@/components/newproducttrial/powerlist'
import applytrial from '@/components/newproducttrial/applytrial'
import submitresult from '@/components/newproducttrial/submitresult'
import applyrecord from '@/components/newproducttrial/applyrecord'
import applylist from '@/components/newproducttrial/applylist'
import trialfeedback from '@/components/newproducttrial/trialfeedback'

//买家秀
import fansShow from '@/components/buyersShow/fansShow'
import askEveryone from '@/components/buyersShow/askEveryone'
import problemDetails from '@/components/buyersShow/problemDetails'

// 会员中心
import vipCenter from '@/components/user/vipCenter'
import viplevelinstructions from '@/components/user/viplevelinstructions'

// 50VIP升级35VIP 网商部同事通过H5创建会议
import applymeeting from '@/components/createmeeting/applymeeting'
import meetingloginin from '@/components/createmeeting/meetingloginin'
import meetingdetail from '@/components/createmeeting/meetingdetail'
import meetinglist from '@/components/createmeeting/meetinglist'
import vipgiftbagdata from '@/components/createmeeting/vipgiftbagdata'

// 购买vip礼包
import vipgiftbagaddOrder from '@/components/upgradeVIP/vipgiftbagaddOrder'
import vipgiftbaglist from '@/components/upgradeVIP/vipgiftbaglist'
import vipgiftbagpayResult from '@/components/upgradeVIP/vipgiftbagpayResult'

// 2024-03-26 函金靓 Start
import beautitysaidDetail from '@/components/community-beautitysaid/detail.vue'
import beautitySaidSearch from '@/components/community-beautitysaid/search'
import beautitySaidSearchResult from '@/components/community-beautitysaid/searchResult'
import beautitySaidProductList from '@/components/community-beautitysaid/productList'
// 2024-03-26 函金靓 End

// 2024-05-30 会员升级 Start
import vipupDetail from '@/components/upgradeVIP/vipupDetail'
import vipupApply from '@/components/upgradeVIP/vipupApply'
import vipupSuccess from '@/components/upgradeVIP/vipupSuccess'
// 2024-05-30 会员升级 End

// 商品列表
import goodsList from '@/components/productdetail/goodsList'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // 登录/注册
    {
      path: '/login',
      name: 'loginIn',
      component: loginIn,
      meta: {
        title: '登录/注册',
        keepAlive: false
      }
    },
    // 输入验证码
    {
      path: '/code',
      name: 'authCode',
      component: authCode,
      meta: {
        title: '输入验证码',
        keepAlive: false
      }
    },
    // 选择国家/地区
    {
      path: '/country',
      name: 'chooseCountry',
      component: chooseCountry,
      meta: {
        title: '选择国家/地区',
        keepAlive: false
      }
    },
    // 选择国家/地区
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: '用户使用协议',
        keepAlive: false
      }
    },
    // 首页
    {
      path: '/',
      name: 'homePage',
      component: homePage,
      meta: {
        title: '创客云商商城',
        keepAlive: true
      }
    },
    // 专区首页
    {
      path: '/indexchannel',
      name: 'homePageChannel',
      component: homePageChannel,
      meta: {
        title: '创客云商商城',
        keepAlive: true
      }
    },
    // 搜索
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: '搜索',
        keepAlive: false
      }
    },
    // 搜索
    {
      path: '/searchlist',
      name: 'searchItemList',
      component: searchItemList,
      meta: {
        title: '搜索',
        keepAlive: true
      }
    },
    {
      path: '/recommendlist',
      name: 'recommendList',
      component: recommendList,
      meta: {
        title: '小编推荐',
        keepAlive: true
      }
    },
    // 消息
    {
      path: '/messagecenter',
      name: 'messageCenter',
      component: messageCenter,
      meta: {
        title: '消息中心',
        keepAlive: false
      }
    },
    {
      path: '/noticemessage',
      name: 'noticeMessage',
      component: noticeMessage,
      meta: {
        title: '官方通知',
        keepAlive: true
      }
    },
    {
      path: '/personmessage',
      name: 'personNoticeMessage',
      component: personNoticeMessage,
      meta: {
        title: '个人消息',
        keepAlive: true
      }
    },
    // 物流助手
    {
      path: '/logisticsmessage',
      name: 'logisticsMessage',
      component: logisticsMessage,
      meta: {
        title: '物流助手',
        keepAlive: true
      }
    },
    // 精选活动
    {
      path: '/selectact',
      name: 'selectActivities',
      component: selectActivities,
      meta: {
        title: '精选活动',
        keepAlive: true
      }
    },
    // 新人有礼
    {
      path: '/newperson',
      name: 'newPerson',
      component: newPerson,
      meta: {
        title: '新人有礼',
        keepAlive: true
      }
    },
    // 新品上市
    {
      path: '/newproduct',
      name: 'newProduct',
      component: newProduct,
      meta: {
        title: '',
        keepAlive: true
      }
    },
    // 热销活动
    {
      path: '/giftbagproduct',
      name: 'giftBagProduct',
      component: giftBagProduct,
      meta: {
        title: '引流活动商品',
        keepAlive: true
      }
    },
    // 畅销榜
    {
      path: '/bestsell',
      name: 'bestSell',
      component: bestSell,
      meta: {
        title: '畅销榜',
        keepAlive: true
      }
    },
    // 我的
    {
      path: '/percen',
      name: 'personalCenter',
      component: personalCenter,
      meta: {
        title: '我的',
        keepAlive: true
      }
    },
    // 浏览足迹
    {
      path: '/footprint',
      name: 'footprint',
      component: footprint,
      meta: {
        title: '浏览足迹',
        keepAlive: false
      }
    },
    // 帮助中心
    {
      path: '/help',
      name: 'help',
      component: help,
      meta: {
        title: '帮助中心',
        keepAlive: false
      }
    },
    // 帮助中心
    {
      path: '/helpcontent',
      name: 'helpContent',
      component: helpContent,
      meta: {
        title: '问题详情',
        keepAlive: false
      }
    },
    // 个人信息
    {
      path: '/perinfo',
      name: 'perInfo',
      component: perInfo,
      meta: {
        title: '个人信息',
        keepAlive: false
      }
    },
    // 修改昵称/姓名
    {
      path: '/update',
      name: 'updateMessage',
      component: updateMessage,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      meta: {
        title: '意见反馈',
        keepAlive: false
      }
    },
    {
      path: '/feedbacklist',
      name: 'feedbackList',
      component: feedbackList,
      meta: {
        title: '我的反馈',
        keepAlive: true
      }
    },
    {
      path: '/feedbackdetails',
      name: 'feedbackDetails',
      component: feedbackDetails,
      meta: {
        title: '反馈详情'
      }
    },
    {
      path: '/aftereval',
      name: 'afterEvaluation',
      component: afterEvaluation,
      meta: {
        title: '售后评价',
        keepAlive: false
      }
    },
    // 设置
    {
      path: '/setting',
      name: 'setting',
      component: setting,
      meta: {
        title: '设置',
        keepAlive: false
      }
    },
    // // 问题帮助
    // {
    //   path: '/help',
    //   name: 'helpCenter',
    //   component: helpCenter,
    //   meta: {
    //     title: '设置',
    //     keepAlive: false
    //   }
    // },
    // 地址管理
    {
      path: '/addmana',
      name: 'addressManagement',
      component: addressManagement,
      meta: {
        title: '我的地址',
        keepAlive: false
      }
    },
    // 新增地址
    {
      path: '/addadd',
      name: 'addAddress',
      component: addAddress,
      meta: {
        title: '新增地址',
        keepAlive: false
      }
    },
    // 编辑地址
    {
      path: '/editadd',
      name: 'editAddress',
      component: editAddress,
      meta: {
        title: '编辑地址',
        keepAlive: false
      }
    },
    // 更换手机号
    {
      path: '/phone',
      name: 'updatePhone',
      component: updatePhone,
      meta: {
        title: '更换手机号',
        keepAlive: false
      }
    },
    {
      path: '/inphone',
      name: 'inputPhone',
      component: inputPhone,
      meta: {
        title: '更换手机号',
        keepAlive: false
      }
    },
    {
      path: '/phonecode',
      name: 'updatePhoneCode',
      component: updatePhoneCode,
      meta: {
        title: '更换手机号',
        keepAlive: false
      }
    },
    {
      path: '/bound',
      name: 'boundPhone',
      component: boundPhone,
      meta: {
        title: '绑定手机号',
        keepAlive: false
      }
    },
    {
      path: '/boundcountry',
      name: 'boundChooseCountry',
      component: boundChooseCountry,
      meta: {
        title: '选择国家/地区',
        keepAlive: false
      }
    },
    {
      path: '/boundcode',
      name: 'boundPhoneCode',
      component: boundPhoneCode,
      meta: {
        title: '绑定手机号',
        keepAlive: false
      }
    },
    {
      path: '/aboutus',
      name: 'aboutUs',
      component: aboutUs,
      meta: {
        title: '关于我们',
        keepAlive: false
      }
    },
    {
      path: '/storeinfo',
      name: 'storeInfo',
      component: storeInfo,
      meta: {
        title: '店铺信息',
        keepAlive: false
      }
    },
    {
      path: '/invfriends',
      name: 'inviteFriends',
      component: inviteFriends,
      meta: {
        title: '邀请好友',
        keepAlive: true
      }
    },
    {
      path: '/cashcoupon',
      name: 'cashCoupon',
      component: cashCoupon,
      meta: {
        title: '卡劵',
        keepAlive: true
      }
    },
    {
      path: '/getcoupon',
      name: 'getcoupon',
      component: getcoupon,
      meta: {
        title: '领券中心',
        keepAlive: false
      }
    },
    {
      path: '/integral',
      name: 'integralCenter',
      component: integralCenter,
      meta: {
        title: '我的金币',
        keepAlive: true
      }
    },
    {
      path: '/integralTask',
      name: 'integralTask',
      component: integralTask,
      meta: {
        title: '赚金币',
        keepAlive: false
      }
    },

    {
      path: '/integraldetails',
      name: 'integralDetails',
      component: integralDetails,
      meta: {
        title: '金币明细',
        keepAlive: false
      }
    },
    {
      path: '/integralrule',
      name: 'integralRule',
      component: integralRule,
      meta: {
        title: '金币规则',
        keepAlive: false
      }
    },
    {
      path: '/integralproduct',
      name: 'integralProductDetail',
      component: integralProductDetail,
      meta: {
        title: '商品详情',
        keepAlive: false
      }
    },
    {
      path: '/newprodetail',
      name: 'newprodetail',
      component: newproductDetail,
      meta: {
        title: '29.9活动详情',
        keepAlive: false
      }
    },
    {
      path: '/addOrderIntegral',
      name: 'addOrderIntegral',
      component: addOrderIntegral,
      meta: {
        title: '订单确认',
        keepAlive: false
      }
    },
    {
      path: '/collect',
      name: 'collection',
      component: collection,
      meta: {
        title: '收藏',
        keepAlive: true
      }
    },
    {
      path: '/myorder',
      name: 'myOrder',
      component: myOrder,
      meta: {
        title: '我的订单',
        keepAlive: true
      }
    },
    {
      path: '/donate',
      name: 'donateList',
      component: donateList,
      meta: {
        title: '我的捐赠',
        keepAlive: true
      }
    },
    {
      path: '/ordersearch',
      name: 'orderSearch',
      component: orderSearch,
      meta: {
        title: '订单搜索',
        keepAlive: false
      }
    },
    {
      path: '/ordsealist',
      name: 'orderSearchList',
      component: orderSearchList,
      meta: {
        title: '订单搜索',
        keepAlive: true
      }
    },
    {
      path: '/orderdetails',
      name: 'orderDetails',
      component: orderDetails,
      meta: {
        title: '订单详情',
        keepAlive: false
      }
    },
    {
      path: '/producteval',
      name: 'productEvaluation',
      component: productEvaluation,
      meta: {
        title: '商品评价',
        keepAlive: false
      }
    },
    {
      path: '/splitdetails',
      name: 'splitDetails',
      component: splitDetails,
      meta: {
        title: '物流详情',
        keepAlive: false
      }
    },
    {
      path: '/splitdetails_order',
      name: 'splitdetails_order',
      component: splitdetails_order,
      meta: {
        title: '物流详情',
        keepAlive: false
      }
    },
    {
      path: '/relationorders',
      name: 'relationorders',
      component: relationorders,
      meta: {
        title: '补发订单列表',
        keepAlive: false
      }
    },
    {
      path: '/aftertype',
      name: 'afterType',
      component: afterType,
      meta: {
        title: '选择售后类型',
        keepAlive: false
      }
    },
    {
      path: '/salesreturn',
      name: 'salesReturn',
      component: salesReturn,
      meta: {
        title: '退货', // 修改退货理由
        keepAlive: false
      }
    },
    {
      path: '/refundsales',
      name: 'refundSalesReturn',
      component: refundSalesReturn,
      meta: {
        title: '', // 退款/退款退货
        keepAlive: false
      }
    },
    {
      path: '/retsubs',
      name: 'ReturnSubsequent',
      component: ReturnSubsequent,
      meta: {
        title: '', // 退货
        keepAlive: false
      }
    },
    // {
    //   path: '/choosecourier',
    //   name: 'chooseCourier',
    //   component: chooseCourier,
    //   meta: {
    //     title: '快递公司',
    //     keepAlive: false
    //   }
    // },
    {
      path: '/afterdetails',
      name: 'afterDetails',
      component: afterDetails,
      meta: {
        title: '售后详情',
        keepAlive: false
      }
    },
    {
      path: '/logistics',
      name: 'logisticsDetails',
      component: logisticsDetails,
      meta: {
        title: '查看物流',
        keepAlive: false
      }
    },
    {
      path: '/prize',
      name: 'myPrize',
      component: myPrize,
      meta: {
        title: '我的奖品',
        keepAlive: true
      }
    },
    {
      path: '/orderprize',
      name: 'addOrderPrize',
      component: addOrderPrize,
      meta: {
        title: '订单确认',
        keepAlive: false
      }
    },
    {
      path: '/getDetails',
      name: 'getDetails',
      component: getDetails,
      meta: {
        title: '领取详情',
        keepAlive: false
      }
    },
    // {
    //   path: '/prizeorder',
    //   name: 'orderDetailsPrize',
    //   component: orderDetailsPrize,
    //   meta: {
    //     title: '订单详情',// 奖品订单详情 作废
    //     keepAlive: false
    //   }
    // },
    {
      path: '/productCategory',
      name: 'productCategory',
      component: productCategory,
      meta: {
        title: '',
        keepAlive: true
      }
    },
    {
      path: '/classification',
      name: 'category',
      component: category,
      meta: {
        title: '分类',
        keepAlive: true
      }
    },
    {
      path: '/brandlist',
      name: 'brandList',
      component: brandList,
      meta: {
        title: '精选专区',
        keepAlive: true
      }
    },
    {
      path: '/productdetail',
      name: 'productDetail',
      component: productDetail,
      meta: {
        title: '', // 商品详情
        keepAlive: false
      }
    },
    {
      path: '/commentDetail',
      name: 'commentDetail',
      component: commentDetail,
      meta: {
        title: '评论详情',
        keepAlive: false
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart,
      meta: {
        title: '购物车', // 购物车
        keepAlive: true
      }
    },
    {
      path: '/addresschoose',
      name: 'addressChoose',
      component: addressChoose,
      meta: {
        title: '选择地址',
        keepAlive: false
      }
    },
    {
      path: '/commentList',
      name: 'commentList',
      component: commentList,
      meta: {
        title: '评论列表',
        keepAlive: true
      }
    },
    {
      path: '/commentList_1',
      name: 'commentList',
      component: commentList,
      meta: {
        title: '评论列表',
        keepAlive: true
      }
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        title: '订单确认',
        keepAlive: false
      }
    },
    {
      path: '/identity',
      name: 'identity',
      component: identity,
      meta: {
        title: '实名认证',
        keepAlive: false
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay,
      meta: {
        title: '支付',
        keepAlive: false
      }
    },
    {
      path: '/payResult',
      name: 'payResult',
      component: payResult,
      meta: {
        title: '支付结果',
        keepAlive: false
      }
    },
    {
      path: '/ndo',
      name: 'ndo',
      component: ndoIndex,
      meta: {
        title: '糖化测试',
        keepAlive: false
      }
    },
    {
      path: '/ndoresult',
      name: 'ndoresult',
      component: ndoResult,
      meta: {
        title: '糖化测试',
        keepAlive: false
      }
    },
    {
      path: '/compro',
      name: 'communityPromoteAct',
      component: communityPromoteAct,
      meta: {
        title: '店铺福利',
        keepAlive: false
      }
    },
    {
      path: '/actintroduce',
      name: 'actintroduce',
      component: actintroduce,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/friendactintroduce',
      name: 'friendactintroduce',
      component: friendactintroduce,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/msindex',
      name: 'msindex',
      component: msindex,
      meta: {
        title: '限时抢购',
        keepAlive: false
      }
    },
    {
      path: '/msproduct',
      name: 'msproductDetail',
      component: msproductDetail,
      meta: {
        title: '秒杀详情页',
        keepAlive: false
      }
    },
    {
      path: '/jzdzlbindex',
      name: 'jzdzlbindex',
      component: jzdzlbindex,
      meta: {
        title: '福利礼包',
        keepAlive: false
      }
    },
    {
      path: '/jzdzlbproduct',
      name: 'jzdzlbproductDetail',
      component: jzdzlbproductDetail,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/community',
      name: 'community',
      component: community,
      meta: {
        title: '社区',
        keepAlive: true
      }
    },
    {
      path: '/communitysearch',
      name: 'communitySearch',
      component: communitySearch,
      meta: {
        title: '搜索',
        keepAlive: false
      }
    },
    {
      path: '/communitysearchresult',
      name: 'communitySearchResult',
      component: communitySearchResult,
      meta: {
        title: '搜索结果',
        keepAlive: true
      }
    },
    {
      path: '/communityevaluation',
      name: 'communityEvaluation',
      component: communityEvaluation,
      meta: {
        title: '发帖',
        keepAlive: true
      }
    },
    {
      path: '/communitytopic',
      name: 'communityTopic',
      component: communityTopic,
      meta: {
        title: '参与话题',
        keepAlive: true
      }
    },
    {
      path: '/crosssellproducts',
      name: 'crossSellProducts',
      component: crossSellProducts,
      meta: {
        title: '关联商品',
        keepAlive: false
      }
    },
    {
      path: '/communitydetail',
      name: 'communityDetail',
      component: communityDetail,
      meta: {
        title: '帖子详情',
        keepAlive: true
      }
    },
    {
      path: '/communityreport',
      name: 'communityReport',
      component: communityReport,
      meta: {
        title: '举报',
        keepAlive: false
      }
    },
    {
      path: '/fanslist',
      name: 'fansList',
      component: fansList,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/communityCenter',
      name: 'communityCenter',
      component: communityCenter,
      meta: {
        title: '个人主页',
        keepAlive: true
      }
    },
    {
      path: '/draftlist',
      name: 'draftList',
      component: draftList,
      meta: {
        title: '草稿箱',
        keepAlive: true
      }
    },
    {
      path: '/topiclist',
      name: 'topicList',
      component: topicList,
      meta: {
        title: '话题广场',
        keepAlive: true
      }
    },
    {
      path: '/communitymsg',
      name: 'communityMsg',
      component: communityMsg,
      meta: {
        title: '消息',
        keepAlive: true
      }
    },
    {
      path: '/communityfollow',
      name: 'communityFollow',
      component: communityFollow,
      meta: {
        title: '关注',
        keepAlive: true
      }
    },
    {
      path: '/certification',
      name: 'certification',
      component: certification,
      meta: {
        title: '创作者',
        keepAlive: false
      }
    },
    {
      path: '/updateintroduce',
      name: 'updateintroduce',
      component: updateintroduce,
      meta: {
        title: '编辑简介',
        keepAlive: false
      }
    },
    {
      path: '/submitsuccessful',
      name: 'submitsuccessful',
      component: submitsuccessful,
      meta: {
        title: '等待审核',
        keepAlive: false
      }
    },
    {
      path: '/rewarddetails',
      name: 'rewarddetails',
      component: rewarddetails,
      meta: {
        title: '打赏明细',
        keepAlive: true
      }
    },
    {
      path: '/creditscoreresume',
      name: 'creditscoreresume',
      component: creditscoreresume,
      meta: {
        title: '信用分履历',
        keepAlive: true
      }
    },
    {
      path: '/datacenter',
      name: 'dataCenter',
      component: dataCenter,
      meta: {
        title: '数据中心',
        keepAlive: false
      }
    },
    {
      path: '/productList',
      name: 'productList',
      component: productList,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/allProductList',
      name: 'allProductList',
      component: allProductList,
      meta: {
        title: '超值福利',
        keepAlive: false
      }
    },
    {
      path: '/product',
      name: 'product',
      component: product,
      meta: {
        title: '超值加购',
        keepAlive: false
      }
    },
    {
      path: '/freeGiftZone',
      name: 'freeGiftZone',
      component: freeGiftZone,
      meta: {
        title: '赠品专区',
        keepAlive: false
      }
    },
    {
      path: '/freegiftzone_buygift',
      name: 'freeGiftZone_buyGift',
      component: freeGiftZone_buyGift,
      meta: {
        title: '赠品专区',
        keepAlive: false
      }
    },
    {
      path: '/recommendProducts',
      name: 'recommendProducts',
      component: recommendProducts,
      meta: {
        title: '搭配订单',
        keepAlive: false
      }
    },
    {
      path: '/exclusivelist',
      name: 'exclusivelist',
      component: exclusivelist,
      meta: {
        title: '专属列表',
        keepAlive: false
      }
    },
    {
      path: '/skinAnalysis',
      name: 'skinAnalysis',
      component: skinAnalysis,
      meta: {
        title: 'AI测肤',
        keepAlive: false
      }
    },
    {
      path: '/analysisDetail',
      name: 'analysisDetail',
      component: analysisDetail,
      meta: {
        title: '肌肤分析结果',
        keepAlive: false
      }
    },

    {
      path: '/analysisDetailposter',
      name: 'analysisDetailposter',
      component: analysisDetailposter,
      meta: {
        title: '肌肤分析结果',
        keepAlive: false
      }
    },
    {
      path: '/skinQuestioin',
      name: 'skinQuestioin',
      component: skinQuestioin,
      meta: {
        title: '最想解决的问题',
        keepAlive: false
      }
    },
    {
      path: '/skinProducts',
      name: 'skinProducts',
      component: skinProducts,
      meta: {
        title: '定制推荐商品',
        keepAlive: false
      }
    },
    {
      path: '/skinRecords',
      name: 'skinRecords',
      component: skinRecords,
      meta: {
        title: '测肤记录',
        keepAlive: false
      }
    },
    {
      path: '/couponproduct',
      name: 'couponproduct',
      component: couponproduct,
      meta: {
        title: '可用商品',
        keepAlive: true
      }
    },
    {
      path: '/personinfofill',
      name: 'personinfofill',
      component: personinfofill,
      meta: {
        title: '个人信息',
        keepAlive: true
      }
    },
    {
      path: '/openingbank',
      name: 'openingbank',
      component: openingbank,
      meta: {
        title: '开户行',
        keepAlive: true
      }
    },
    {
      path: '/identityauth',
      name: 'identityauth',
      component: identityauth,
      meta: {
        title: '身份认证',
        keepAlive: false
      }
    },
    {
      path: '/identityauthsucc',
      name: 'identityauthsucc',
      component: identityauthsucc,
      meta: {
        title: '身份认证',
        keepAlive: true
      }
    },
    {
      path: '/emplmsindex',
      name: 'emplmsindex',
      component: emplmsindex,
      meta: {
        title: '员工福利',
        keepAlive: false
      }
    },
    // 新品试用
    {
      path: '/newproducthome',
      name: 'newproducthome',
      component: newproducthome,
      meta: {
        title: '新品试用',
        keepAlive: true
      }
    },
    {
      path: '/newproductdetail',
      name: 'newproductdetail',
      component: newproductdetail,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/powerlist',
      name: 'powerlist',
      component: powerlist,
      meta: {
        title: '助力',
        keepAlive: false
      }
    },
    {
      path: '/applytrial',
      name: 'applytrial',
      component: applytrial,
      meta: {
        title: '申请试用',
        keepAlive: false
      }
    },
    {
      path: '/submitresult',
      name: 'submitresult',
      component: submitresult,
      meta: {
        title: '提交成功',
        keepAlive: false
      }
    },
    {
      path: '/applyrecord',
      name: 'applyrecord',
      component: applyrecord,
      meta: {
        title: '申请记录',
        keepAlive: false
      }
    },
    {
      path: '/applylist',
      name: 'applylist',
      component: applylist,
      meta: {
        title: '申请列表',
        keepAlive: false
      }
    },
    {
      path: '/trialfeedback',
      name: 'trialfeedback',
      component: trialfeedback,
      meta: {
        title: '试用反馈',
        keepAlive: true
      }
    },
    {
      path: '/fansShow',
      name: 'fansShow',
      component: fansShow,
      meta: {
        title: '金粉秀',
        keepAlive: false
      }
    },
    {
      path: '/askEveryone',
      name: 'askEveryone',
      component: askEveryone,
      meta: {
        title: '问大家',
        keepAlive: false
      }
    },
    {
      path: '/problemDetails',
      name: 'problemDetails',
      component: problemDetails,
      meta: {
        title: '问题详情',
        keepAlive: false
      }
    },
    {
      path: '/vipcenter',
      name: 'vipCenter',
      component: vipCenter,
      meta: {
        title: '会员中心',
        keepAlive: false
      }
    },
    {
      path: '/instructions',
      name: 'viplevelinstructions',
      component: viplevelinstructions,
      meta: {
        title: '会员等级说明',
        keepAlive: false
      }
    },
    {
      path: '/meetingloginin',
      name: 'meetingloginin',
      component: meetingloginin,
      meta: {
        title: '登录/注册',
        keepAlive: false
      }
    },
    {
      path: '/applymeeting',
      name: 'applymeeting',
      component: applymeeting,
      meta: {
        title: '申请会议',
        keepAlive: true
      }
    },
    {
      path: '/meetingdetail',
      name: 'meetingdetail',
      component: meetingdetail,
      meta: {
        title: '会议详情',
        keepAlive: false
      }
    },
    {
      path: '/meetinglist',
      name: 'meetinglist',
      component: meetinglist,
      meta: {
        title: '会议列表',
        keepAlive: true
      }
    },
    {
      path: '/vipgiftbagdata',
      name: 'vipgiftbagdata',
      component: vipgiftbagdata,
      meta: {
        title: '礼包数据',
        keepAlive: true
      }
    },
    {
      path: '/vipgiftbagaddorder',
      name: 'vipgiftbagaddOrder',
      component: vipgiftbagaddOrder,
      meta: {
        title: '订单确认',
        keepAlive: false
      }
    },
    {
      path: '/vipgiftbaglist',
      name: 'vipgiftbaglist',
      component: vipgiftbaglist,
      meta: {
        title: '购买VIP礼包',
        keepAlive: true
      }
    },
    {
      path: '/vipgiftbagpayresult',
      name: 'vipgiftbagpayResult',
      component: vipgiftbagpayResult,
      meta: {
        title: '支付结果',
        keepAlive: false
      }
    },
    // 2024-03-26 函金靓 Start
    {
      path: '/beautitysaiddetail',
      name: 'beautitysaidDetail',
      component: beautitysaidDetail,
      meta: {
        title: '函金靓',
        keepAlive: true
      }
    },
    {
      path: '/bs',
      name: 'beautitySaidSearch',
      component: beautitySaidSearch,
      meta: {
        title: '搜索',
        keepAlive: false
      }
    },
    {
      path: '/bsr',
      name: 'beautitySaidSearchResult',
      component: beautitySaidSearchResult,
      meta: {
        title: '搜索结果',
        keepAlive: false
      }
    },
    {
      path: '/bspl',
      name: 'beautitySaidProductList',
      component: beautitySaidProductList,
      meta: {
        title: '精选好物',
        keepAlive: false
      }
    },
    // 2024-03-26 函金靓 End

    // 2024-05-30 会员升级 Start
    {
      path: '/vip',
      name: 'vipupDetail',
      component: vipupDetail,
      meta: {
        title: '50VIP',
        keepAlive: false
      }
    },
    {
      path: '/vipapply',
      name: 'vipupApply',
      component: vipupApply,
      meta: {
        title: '申请成为50VIP',
        keepAlive: false
      }
    },
    {
      path: '/vipupsucc',
      name: 'vipupSuccess',
      component: vipupSuccess,
      meta: {
        title: '下载APP',
        keepAlive: false
      }
    },
    // 2024-05-30 会员升级 End
    {
      path: '/goodslist',
      name: 'goodsList',
      component: goodsList,
      meta: {
        title: '热销好评',
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js